interface StageKeys {
   inputs: Record<string, string>;
   outputs: Record<string, string>;
}

interface HorizonKeys {
    cap_setting: StageKeys;
    cycle_transfer: StageKeys;
    ct_override: StageKeys;
    cap_release: StageKeys;
    cap_deployment: StageKeys;
}

export const S3_KEYS: Record<string, Record<string, HorizonKeys>> = {
    AMZL: {
        'D-1': {
            cap_setting: {
                inputs: {
                    spr: 'user_uploads/D-1/spr/{batchId}-{round}-SPR.csv',
                    volume_forecast: 'user_uploads/D-1/volume_forecast/{batchId}-{round}-Volume-Forecast.csv',
                    utr_constraint: 'user_uploads/D-1/utr/{batchId}-{round}-UTR-Constraint.csv',
                    flex_incremental: 'user_uploads/D-1/flex-incremental/{batchId}-{round}-Flex-Increment.csv',
                    vovi_forecast: 'user_uploads/D-1/vovi-forecast/{batchId}-{round}-VoVi-Forecast.csv',
                    earlies: 'user_uploads/D-1/earlies/{batchId}-{round}-Earlies.csv',
                    hub_capacity: 'user_uploads/D-1/hub_capacity/{batchId}-{round}-Hub-Capacity.csv',
                },
                outputs: {
                    otr_capacity: 'output/D-1/cap_setting/{batchId}-{round}-OTR-Capacity.csv',
                    otr_capacity_log: 'logs/D-1/cap_setting/{batchId}-{round}-OTR-Capacity-Log.csv',
                    utr_capacity: 'output/D-1/cap_setting/{batchId}-{round}-UTR-Capacity.csv',
                    utr_capacity_log: 'logs/D-1/cap_setting/{batchId}-{round}-UTR-Capacity-Log.csv',
                },
            },
            cycle_transfer: {
                inputs: {
                    otr_capacity: 'output/D-1/cap_setting/{batchId}-{round}-OTR-Capacity.csv',
                    utr_capacity: 'output/D-1/cap_setting/{batchId}-{round}-UTR-Capacity.csv',
                },
                outputs: {
                    cycle_transfer: 'output/D-1/cycle_transfer/{batchId}-{round}-Cycle-Transfer.csv',
                    cycle_transfer_log: 'logs/D-1/cycle_transfer/{batchId}-{round}-Cycle-Transfer-Log.csv',
                },
            },
            ct_override: {
                inputs: {
                    ct_override: 'user_uploads/D-1/ct-override/{batchId}-{round}-CT-Override.csv',
                },
                outputs: {
                    ct_override: 'output/D-1/ct_override/{batchId}-{round}-CT-Override.csv',
                    ct_override_log: 'logs/D-1/ct_override/{batchId}-{round}-CT-Override-Log.csv',
                },
            },
            cap_release: {
                inputs: {
                    utr_capacity: 'output/D-1/cap_setting/{batchId}-{round}-UTR-Capacity.csv',
                    cycle_transfer: 'output/D-1/cycle_transfer/{batchId}-{round}-Cycle-Transfer.csv',
                },
                outputs: {
                    cap_release_cims: 'output/D-1/cap_release/{batchId}-{round}-Cap-Release-CIMS.xlsx',
                    cap_release_log: 'logs/D-1/cap_release/{batchId}-{round}-Cap-Release-Log.csv',
                },
            },
            cap_deployment: {
                inputs: {
                    cims_file: "user_uploads/{horizon}/cap_deployment/{batchId}-{round}-CIMS-Upload.xlsx",
                },
                outputs: {},
            },
        },
        'D-2': {
            cap_setting: {
                inputs: {
                    spr: "user_uploads/D-2/spr/{batchId}-{round}-SPR.csv",
                    volume_forecast: "user_uploads/D-2/volume_forecast/{batchId}-{round}-Volume-Forecast.csv",
                    utr_constraint: "user_uploads/D-2/utr/{batchId}-{round}-UTR-Constraint.csv",
                    flex_incremental: "user_uploads/D-2/flex-incremental/{batchId}-{round}-Flex-Increment.csv",
                    vovi_forecast: "user_uploads/D-2/vovi-forecast/{batchId}-{round}-VoVi-Forecast.csv",
                    hub_capacity: "user_uploads/D-2/hub_capacity/{batchId}-{round}-Hub-Capacity.csv",
                },
                outputs: {
                    otr_capacity: "output/D-2/cap_setting/{batchId}-{round}-OTR-Capacity.csv",
                    otr_capacity_log: "logs/D-2/cap_setting/{batchId}-{round}-OTR-Capacity-Log.csv",
                    utr_capacity: "output/D-2/cap_setting/{batchId}-{round}-UTR-Capacity.csv",
                    utr_capacity_log: "logs/D-2/cap_setting/{batchId}-{round}-UTR-Capacity-Log.csv",
                },
            },
            cycle_transfer: {
                inputs: {},
                outputs: {
                    cycle_transfer: "output/D-2/cycle-transfer/{batchId}-{round}-Cycle-Transfer.csv",
                    cycle_transfer_log: "logs/D-2/cycle-transfer/{batchId}-{round}-Cycle-Transfer-Log.csv",
                },
            },
            ct_override: {
                inputs: {
                    ct_override: 'user_uploads/D-2/ct-override/{batchId}-{round}-CT-Override.csv',
                },
                outputs: {
                    ct_override: 'output/D-2/ct_override/{batchId}-{round}-CT-Override.csv',
                    ct_override_log: 'logs/D-2/ct_override/{batchId}-{round}-CT-Override-Log.csv',
                },
            },
            cap_release: {
                inputs: {},
                outputs: {
                    cap_release_cims: "output/D-2/cap_release/{batchId}-{round}-Cap-Release-CIMS.xlsx",
                    cap_release_log: "logs/D-2/cap_release/{batchId}-{round}-Cap-Release-Log.csv",
                },
            },
            cap_deployment: {
                inputs: {
                    cims_file: "user_uploads/D-2/cap_deployment/{batchId}-{round}-CIMS-Upload.xlsx",
                },
                outputs: {},
            },
        }
    },
};

export function resolveS3Key(template: string, params: Record<string, string>): string {
    return Object.entries(params).reduce(
        (key, [k, v]) => key.replace(`{${k}}`, v),
        template,
    );
}